// Only idempotent, public city reads are eligible. Never replay payments or writes.
const RETRYABLE_READS = new Set(['locations', 'workers', 'amount-distribution', 'cities/ai-content']);
export const retryPublicRead = async (request, { name, cancelToken, wait = ms => new Promise(resolve => setTimeout(resolve, ms)) }) => {
  for (let attempt = 0; ; attempt += 1) {
    if (cancelToken) cancelToken.throwIfRequested();
    try {
      return await request();
    } catch (error) {
      if (!RETRYABLE_READS.has(name) || error?.response?.status !== 503 || attempt >= 2) throw error;
      const after = Number(error.response.headers?.['retry-after']);
      const delay = Number.isFinite(after) && after > 0 ? Math.min(after * 1000, 2000) : [300, 900][attempt];
      await wait(delay);
    }
  }
};
